import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Box, List, Paper, ListItem, ListItemText, ListSubheader } from '@material-ui/core';
import i18n from 'i18n-js';
import { useStyles } from './NocCalendar.styled';

/**
 * Selected item on noc calendar
 */
const SelectedItemPopup = ({ item, position, handleClose, goToSubscription }) => {
  const classes = useStyles();
  const ref = useRef(null);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element and close the popup
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleClose();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handleClose]);

  const getItemName = (item) => {
    const fullName = item?.user?.first_name
      ? `${item?.user?.last_name}, ${item?.user?.first_name}`
      : item?.service?.name;
    const userName = item?.name || item?.user?.name || fullName || `${item?.service?.name}` || '';

    return userName.toUpperCase();
  };

  return (
    <Box ref={ref} zIndex={1000} position="fixed" top={position.y + 20} left={position.x - 20}>
      <Paper elevation={3} className={classes.itemPopup}>
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">
              {`${item.id} - ${getItemName(item)}`}
            </ListSubheader>
          }
          className={classes.root}
        >
          <ListItem button onClick={() => goToSubscription(item)}>
            <ListItemText
              classes={{
                primary: classes.listItem,
              }}
              primary={i18n.t('dashboard.noc_go_to_subscription')}
            />
          </ListItem>
        </List>
      </Paper>
      <Box className={classes.itemPopupContainer}>
        <Box className={classes.itemPopupArrow} />
      </Box>
    </Box>
  );
};

SelectedItemPopup.propTypes = {
  item: PropTypes.object.isRequired,
  position: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  requestType: PropTypes.string.isRequired,
  goToReservation: PropTypes.func.isRequired,
  enableSubscription: PropTypes.bool.isRequired,
};

SelectedItemPopup.defaultProps = {
  requestType: '',
  handleClose: () => {},
  goToReservation: () => {},
  enableSubscription: false,
  handleChangeReservationTimes: () => {},
};

export default SelectedItemPopup;
